import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { AUTH_CONFIG } from "@/constants";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";

export interface WorkosOrganizationOption {
  id: string;
  name: string;
  external_id: string | null;
}

interface WorkosOrganizationsResponse {
  items: WorkosOrganizationOption[];
}

export const useWorkosOrganizations = (organizationId: number | null, enabled: boolean) => {
  const userToken = useAuth()?.userToken;
  return useQuery<WorkosOrganizationsResponse>({
    queryKey: ["identity", "workos-organizations", organizationId],
    enabled: enabled && AUTH_CONFIG.isOnPrem && organizationId !== null && Boolean(userToken),
    queryFn: async () =>
      fetch(ENDPOINTS.identity.workos_organizations(organizationId!), {
        headers: { Authorization: `Bearer ${userToken ?? ""}` },
      }).then(handleResponse),
  });
};
